/**
 * Represents a hyperlink component that encapsulates a link's properties and provides a handler to open the link.
 *
 * @class
 * @param {Object} item - The hyperlink data.
 * @param {string} item.url - The URL to open when the hyperlink is activated.
 * @param {string} [item.target='_self'] - The target window or frame for the hyperlink.
 */
class Hyperlink {
  constructor(item) {
    this.node = item;
    this.href = item.href;
    this.target = item.target || '_self';
  }

  getNode() {
    return this.node;
  }

  handler() {
    window.open(this.href, this.target);
  }
}

export default Hyperlink;
